module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"questionTextPlaceholder":"Question text*","addImage":"Add an image","addAnother":"Change the image","pointsForQuestion":"Points per question","charactersLimit":"The maximum number of characters is","requiredField":"This field is required","ok":"Ok","question":"Question","selectChoice":"multiple choice","numericalChoice":"numerical answer","textChoice":"fill in the blank"}}')
  delete Component.options._Ctor
}
